import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Rankings from "../pages/rankings/page";
import Articles from "../pages/articles/page";
import ArticleDetail from "../pages/article/page";
import Faq from "../pages/faq/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/rankings",
    element: <Rankings />,
  },
  {
    path: "/articles",
    element: <Articles />,
  },
  {
    path: "/article/:id",
    element: <ArticleDetail />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;